import styled from 'styled-components';
import { SxProps } from '@mui/material';
import dayjs from 'dayjs';
import { Flex } from '../Flex';
import DatePicker from '../DatePicker/DatePicker';

const Wrapper = styled(Flex)`
  gap: 8px;
  align-items: center;
`;

export type DateRangeValue = {
  start: dayjs.Dayjs | null;
  end: dayjs.Dayjs | null;
};

type Props = {
  value?: DateRangeValue;
  onChange: (newValue: DateRangeValue) => void;
  format?: string;
  disableFuture?: boolean;
  fromLabel?: string;
  toLabel?: string;
  sx?: SxProps;
};

const DateRangePicker = ({
  value,
  onChange,
  format = 'LL',
  fromLabel = 'Start',
  toLabel = 'End',
  disableFuture = false,
  sx,
}: Props) => (
  <Wrapper sx={sx}>
    <DatePicker
      label={fromLabel}
      value={value?.start}
      onChange={(newValue) => {
        onChange({
          start: newValue,
          end: newValue?.isAfter(value?.end) ? null : value?.end || null,
        });
      }}
      maxDate={value?.end || undefined}
      disableFuture={disableFuture}
      format={format}
    />
    -
    <DatePicker
      label={toLabel}
      value={value?.end}
      onChange={(newValue) => {
        onChange({
          start: newValue?.isBefore(value?.start) ? null : value?.start || null,
          end: newValue,
        });
      }}
      minDate={value?.start || undefined}
      format={format}
      disableFuture={disableFuture}
    />
  </Wrapper>
);

export default DateRangePicker;
